(()=>{
if(window.vfFaqPageLoaded)return;
window.vfFaqPageLoaded=true;
let opener=null;
const normalize=text=>text.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'');
function search(dialog,value){
 const root=dialog.closest('[data-vf-faq-page]');
 if(!root)return;
 const tokens=normalize(value).trim().split(/\s+/).filter(Boolean);
 const matches=[...root.querySelectorAll('[data-question]')].filter(q=>tokens.every(t=>normalize(q.textContent).includes(t)));
 const results=dialog.querySelector('[data-faq-results]');results.replaceChildren();
 dialog.querySelector('[data-faq-count]').textContent=dialog.dataset.count.replace('{count}',matches.length);
 if(!matches.length){const p=document.createElement('p');p.textContent=dialog.dataset.empty;results.append(p);return}
 matches.forEach(q=>{
  const button=document.createElement('button');button.type='button';button.className='vf-faq-search-result';
  button.append(document.createTextNode(q.querySelector('summary').textContent.trim()));
  const label=document.createElement('span');label.textContent=q.closest('[data-group]').querySelector('h2').textContent;button.append(label);
  button.addEventListener('click',()=>{dialog.close();q.open=true;history.replaceState(null,'','#'+q.id);requestAnimationFrame(()=>{q.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});q.querySelector('summary').focus({preventScroll:true})})});results.append(button);
 });
}
function init(scope=document){
 scope.querySelectorAll('.vf-faq-search-dialog').forEach(dialog=>{
  if(dialog.dataset.initialized)return;dialog.dataset.initialized='true';
  dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close()}});
  dialog.addEventListener('close',()=>{if(opener?.isConnected)opener.focus()});
 });
 scope.querySelectorAll('[data-vf-faq-page]').forEach(root=>{
  if(root.dataset.initialized)return;root.dataset.initialized='true';
  const nav=[...root.querySelectorAll('[data-topic]')];
  const active=id=>nav.forEach(a=>{if(a.dataset.topic===id)a.setAttribute('aria-current','location');else a.removeAttribute('aria-current')});
  nav.forEach(a=>a.addEventListener('click',()=>active(a.dataset.topic)));
  if('IntersectionObserver'in window){const observer=new IntersectionObserver(entries=>{const visible=entries.filter(e=>e.isIntersecting).sort((a,b)=>a.boundingClientRect.top-b.boundingClientRect.top);if(visible[0])active(visible[0].target.dataset.group)},{rootMargin:'-130px 0px -50% 0px',threshold:0});root.querySelectorAll('[data-group]').forEach(g=>observer.observe(g));root.vfFaqObserver=observer}
 });
}
document.addEventListener('click',event=>{
 const close=event.target.closest('[data-faq-close]');if(close){close.closest('dialog')?.close();return}
 const button=event.target.closest('[data-faq-open],[data-faq-contact]');if(!button)return;
 const dialog=button.hasAttribute('data-faq-contact')?document.querySelector('[data-faq-contact-dialog]'):document.getElementById(button.dataset.faqOpen);
 if(!dialog)return;
 opener=button;dialog.showModal();
 if(dialog.hasAttribute('data-faq-search')){const input=dialog.querySelector('[data-faq-query]');input.value='';search(dialog,'');input.focus()}
});
document.addEventListener('input',event=>{if(event.target.matches('[data-faq-query]'))search(event.target.closest('dialog'),event.target.value)});
document.addEventListener('shopify:section:load',event=>init(event.target));
document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-vf-faq-page]').forEach(root=>root.vfFaqObserver?.disconnect()));
document.addEventListener('shopify:block:select',event=>{const details=event.target.closest('[data-question]');if(details)details.open=true});
init();
if(location.hash){const target=document.getElementById(location.hash.slice(1));if(target?.matches('[data-question]'))target.open=true}
})();
